import { useMutation } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

interface CancelGenerationParams {
  threadId: string;
}

/**
 * React Query hook for cancelling thread generation.
 *
 * @returns Mutation object with mutate/mutateAsync functions and loading/error states
 *
 * @example
 * ```tsx
 * const cancelGeneration = useCancelGeneration();
 *
 * const handleCancel = async () => {
 *   try {
 *     await cancelGeneration.mutateAsync({ threadId: "thread_123" });
 *     console.log("Cancellation requested");
 *   } catch (error) {
 *     console.error("Failed to cancel:", error);
 *   }
 * };
 * ```
 */
export function useCancelGeneration() {
  const { agentThreadService } = useDomainServices();

  return useMutation<void, Error, CancelGenerationParams>({
    mutationFn: async ({ threadId }) => {
      return agentThreadService.cancelGeneration(threadId);
    },
  });
}
